import PropTypes from 'prop-types';

// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// assets
import EditOutlined from '@ant-design/icons/EditOutlined';
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import { useNavigate } from 'react-router-dom';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab({ onClose }) {

  const mainUser = JSON.parse(sessionStorage.getItem("main-user"));
  const role = mainUser?.roleId?.name.toLowerCase() || mainUser?.user?.roleId?.name.toLowerCase();
  const id = mainUser?._id || mainUser?.user?._id;
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem("sessionToken");
    sessionStorage.clear();
    navigate('/login');
  };


  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton
        onClick={() => {
          if (role === 'institution') {
            navigate(`/${role}/profile/edit/${id}/edit`)
          } else {
            navigate(`/${role}/users/edit-userprofile/${id}`)
          }
          onClose(new Event('click'));
        }}
      >
        <ListItemIcon>
          <EditOutlined />
        </ListItemIcon>
        <ListItemText primary="Edit Profile" />
      </ListItemButton>
      <ListItemButton
        onClick={() => {
          if (role === 'institution') {
            navigate(`/${role}/profile/view/${id}`)
          } else {
            navigate(`/${role}/users/view-userprofile/${id}`)
          }
          onClose(new Event('click'));
        }}
      >
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
        <ListItemText primary="View Profile" />
      </ListItemButton>
      <ListItemButton onClick={handleLogout}>
        <ListItemIcon>
          <LogoutOutlined style={{ color: 'red' }} />
        </ListItemIcon>
        <ListItemText primary="Logout" style={{ color: 'red' }} />
      </ListItemButton>
    </List>
  );
}

ProfileTab.propTypes = { handleLogout: PropTypes.func };
